import { z } from 'zod'
import { Model } from './architecture'

export const UrlValidation = z.object({
  value: z.string({ required_error: '[Url] value is required' }),
})

export class Url extends Model {
  static create({ value }: z.infer<typeof UrlValidation>) {
    UrlValidation.parse({ value })
    return new Url(value)
  }

  static fromJSON(json: ReturnType<Url['toJSON']>) {
    return new Url(json.value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
